import styled from "styled-components";

export const ModalWrapper = styled.div`
  
`;

export const GroupsGridWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  overflow-y: auto;
  padding-right: 8px;
  max-height: 376px;

  @media (min-width: 769px) {
    & > * {
      flex: 0 0 calc(50% - 6px);
    }
  }

  @media (max-width: 768px) {
    flex-direction: column;
    & > * {
      flex: 0 0 100%;
    }
  }

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: ${props => props.theme.colors.highClearGray};
  }
  
  &::-webkit-scrollbar-thumb {
    background: ${props => props.theme.colors.border};
    border-radius: 3px;
  }
`;

export const ModalBodyContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const ContentHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
    
   & > div:first-child > div{
     width: auto;
   } 
`;

export const SearchFieldWrapper = styled.div`
  max-width: 257px;
  width: 100%;
`;

export const SelectedItemsWrapper = styled.div`
  display: ${(props) => props.selectedGroups ? 'flex' : 'none'};
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-height: 64px;
  gap: 12px;
  background: ${(props) => props.theme.colors.titanWhite};
  border-radius: 8px;
  padding: 13px;  
`;

export const SelectedItemsRolesWrapper = styled.div`
  display: ${(props) => props.selectedRoles > 0 ? 'flex' : 'none'};
  flex-direction: row;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  min-height: 64px;
  gap: 12px;
  background: ${(props) => props.theme.colors.titanWhite};
  border-radius: 8px;
  padding: 13px;  
`;


export const SelectedItemsContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex: 1 1 auto;
  gap: 12px;
  overflow-x: auto;
  position: relative;
`;

export const SelectedItemsAction = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  align-self: center;
`;

export const SelectedGroupsText = styled.div`
  font-size: 14px;
  line-height: 20px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-word;
  
  span {
    font-weight: 500;
  }
`;

export const MeasureText = styled.div`
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  visibility: hidden;
  height: auto;
  width: 100%;
  word-break: break-word;
  white-space: normal;
  top: 0;
  left: 0;
`;


export const LoadMoreButtonWrapper = styled.div`
  width: auto;
  display: flex;
  justify-content: flex-start;
`;
export const LoadMoreButtonContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-start;
  padding: 16px 0;

  & > button {
    padding: 8px 0px !important;
  }
`;

export const LoadingContainer = styled.div`
  flex: 0 0 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
`;